export default "__VITE_ASSET__05acc447__"